import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Mail } from "lucide-react";
import { api } from "../../lib/api";

const btn = "text-xs px-3 py-2 border border-zinc-900 inline-flex items-center gap-1 hover:bg-zinc-900 hover:text-white";

// Ready-made outreach email for sending manually until email automation is on.
export default function AdminOutreachDraft({ rescue, headers }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get(`/admin/urgent-rescues/${rescue.id}/outreach-draft`, { headers }).then(({ data }) => setD(data)).catch(() => setD(false));
  }, [rescue.id, headers]);
  if (d === null) return null;
  if (d === false) return <p className="text-xs text-red-600">Could not load the outreach email.</p>;

  const copy = async (text, msg) => {
    try { await navigator.clipboard.writeText(text); toast.success(msg); } catch { toast.error("Copy failed — select the text manually."); }
  };
  const bcc = d.recipients.join(",");
  const mailto = `mailto:?${bcc && bcc.length < 1500 ? `bcc=${encodeURIComponent(bcc)}&` : ""}subject=${encodeURIComponent(d.subject)}&body=${encodeURIComponent(d.body)}`;
  return (
    <div className="border border-zinc-300 bg-white p-4 space-y-2 max-w-2xl" data-testid="outreach-draft">
      <div className="text-[11px] font-bold uppercase tracking-widest">Prepared outreach email — send from your own email</div>
      <div className="text-sm"><b>Subject:</b> <span data-testid="outreach-subject">{d.subject}</span></div>
      <textarea readOnly rows={10} value={d.body} className="w-full border border-zinc-300 px-2 py-1.5 text-sm font-mono" data-testid="outreach-body" />
      <div className="text-xs text-zinc-600" data-testid="outreach-recipient-count">{d.recipients.length} rescue partner / shelter emails on file (same state)</div>
      <div className="flex flex-wrap gap-2">
        <a href={mailto} className={btn} data-testid="outreach-open-email"><Mail size={12} /> Open in my email app</a>
        <button type="button" onClick={() => copy(`${d.subject}\n\n${d.body}`, "Email text copied.")} className={btn} data-testid="outreach-copy-text"><Copy size={12} /> Copy email text</button>
        <button type="button" disabled={!d.recipients.length} onClick={() => copy(bcc, "Recipient list copied — paste into BCC.")} className={`${btn} disabled:opacity-40`} data-testid="outreach-copy-recipients"><Copy size={12} /> Copy recipients (BCC)</button>
      </div>
    </div>
  );
}
